import { Component, OnInit } from '@angular/core';
import {DataService} from '../data.service';
import { CountryService } from '../country.service';
import {Router, ActivatedRoute} from '@angular/router';
import {IMyDpOptions, IMyDateModel, IMyDate} from 'mydatepicker';
import {NgForm} from '@angular/forms';
import { AmazingTimePickerService } from 'amazing-time-picker';
import {ChangeDetectorRef } from '@angular/core';


declare var $: any;
declare var body: any;
declare var google: any;
declare var Nanobar: any;
declare var toastr: any;
declare var moment: any;

@Component({
  selector: 'app-events',
  templateUrl: './events.component.html',
  styleUrls: ['./events.component.css']
})
export class EventsComponent implements OnInit {

  nao = new Nanobar();
  eventsData: any;
  eventDeleteData: any;
  deleteEventsId: any;
  editEventsId: any;
  loadindData = true;
  paginatedDataEvents: any;
  customerPaginatedDataEvents: any;
  eventsPageCount = 0;
  customerPageCount = 0;
  eventsLastPage = true;
  customerLastPage = true;
  deleteBtndDisable = false;
  limit = 25;
  messagesDetail: any;
  serviceAreaListing: any;
  serviceAreaData: any;
  businessListing: any;
  addEventType = 1;
  private today = new Date();
  selDate: any;
  currentYear = this.today.getUTCFullYear();
  currentDate = this.today.getUTCDate() - 1;
  currentMonth = this.today.getUTCMonth() + 1;
  myDatePickerOptions: IMyDpOptions = {
    dateFormat: 'mm/dd/yyyy',
    showTodayBtn: true,
    todayBtnTxt: 'Today',
    showClearDateBtn: false,
    indicateInvalidDate: true,
    editableDateField: false,
    openSelectorOnInputClick: true,
    disableUntil: {year: this.currentYear, month: this.currentMonth, day: this.currentDate},
  };

  time = '';
  date: any;
  title = '';
  text = '';
  eventType = '0';
  phoneNumberRegion = '0';
  business = '0';
  region = '0';
  noOfOrder = {
    'value': null,
    'filter': '0',
    'filterValue': 'All',
    'disable': true
  };
  spendingAmount = {
    'value': null,
    'filter': '0',
    'filterValue': 'All',
    'disable': true
  };
  age = {
    'value': null,
    'filter': '0',
    'filterValue': 'All',
    'disable': true
  };
  orderCondition = {
    'filter': '0',
    'filterValue': 'AND',
  };
  disableBtn = false;
  addEventData: any;
  customerEventData: any;
  customerEventTotal = 0;
  editEvent = false;
  editDisable = false;
  constructor(private dataService: DataService, private router: Router, private atp: AmazingTimePickerService, private chRef: ChangeDetectorRef) { }
  getEvents() {
    this.loadindData = true;
    this.nao.go(30);
    var dayForTime = new Date();
    var currentSystemTime = dayForTime.getTimezoneOffset();
    currentSystemTime = currentSystemTime / 60;
    this.dataService.getEventslisting(window.localStorage.getItem('token'), currentSystemTime, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.eventsData = data;
        this.eventsLastPage = this.eventsData.last_page;
        this.eventsPageCount++;
        this.eventsData = this.eventsData.items;
        this.loadindData = false;
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  getEventslistingByPageFunction() {
    this.nao.go(30);
    console.log('login data');
    var dayForTime = new Date();
    var currentSystemTime = dayForTime.getTimezoneOffset();
    currentSystemTime = currentSystemTime / 60;
    this.dataService.getEventslistingByPage(window.localStorage.getItem('token'), this.eventsPageCount, currentSystemTime, this.limit).subscribe(
      (data) => {
        this.nao.go(100);
        this.paginatedDataEvents = data;
        this.eventsLastPage = this.paginatedDataEvents.last_page;
        this.eventsPageCount++;
        this.paginatedDataEvents = this.paginatedDataEvents.items;
        for ( var i = 0; i < this.paginatedDataEvents.length; i++) {
          this.eventsData.push(this.paginatedDataEvents[i]);
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }
  openDeleteEventsPopup(id) {
    this.deleteBtndDisable = false;
    this.deleteEventsId = id;
    $('#deleteEventsPopup').modal('show');
  }
  deleteConform() {
    this.deleteBtndDisable = true;
    this.nao.go(30);
    this.dataService.deleteEvent(window.localStorage.getItem('token'), this.deleteEventsId).subscribe(
      (data) => {
        this.nao.go(100);
        this.eventDeleteData = data;
        this.deleteBtndDisable = false;
        if ( this.eventDeleteData.success === true ) {
          this.getEvents();
          $('#deleteEventsPopup').modal('hide');
          toastr.success('Event cancel successfuly');
        } else {
          toastr.success('Something went wrong');
        }
      },
      (error) => {
        this.nao.go(100);
        console.log('error', error);
      }
    );
  }


  serviceAreaList() {
    this.dataService.getServiceAreaListWithBusiness(window.localStorage.getItem('token')).subscribe(
      (data) => {
        this.serviceAreaData = data;
        this.serviceAreaListing = this.serviceAreaData.service_area_list;
        this.businessListing = this.serviceAreaData.all_business_list;
      },
      (error) => {
      }
    );
  }

  callAddEventFun(){
    this.editEventsId = -1;
    this.editDisable = false;
    this.serviceAreaListing = this.serviceAreaData.service_area_list;
    this.businessListing = this.serviceAreaData.all_business_list;
    this.disableBtn = false;
    this.editEvent = false;
    this.text = '';
    this.title = '';
    this.date = null;
    $('#time').val(null);
    $('#eventType').val('0');
    $('#region').val('0');
    $('#business').val('0');
    $('#phoneNumberRegion').val('0');

    this.spendingAmount = {
      'value': null,
      'filter': '0',
      'filterValue': 'All',
      'disable': true
    };
    this.noOfOrder = {
      'value': null,
      'filter': '0',
      'filterValue': 'All',
      'disable': true
    };
    this.age = {
      'value': null,
      'filter': '0',
      'filterValue': 'All',
      'disable': true
    };
    $('#addEvent').modal('show');
  }

  updateBusinessList(event){
   event = Number(event);
   if ( event === 0 ) {
     this.businessListing = this.serviceAreaData.all_business_list;
   } else {
     for ( var i = 0; i < this.serviceAreaListing.length; i++ ) {
       if ( this.serviceAreaListing[i].id === event ) {
         this.businessListing = this.serviceAreaListing[i].business_list;
       }
     }
   }
  }
  updateEventType(type){
    this.eventType = type;
  }
  restrictUserInput($event) {
    $event.preventDefault();
  }
  openTimePop() {
    const amazingTimePicker = this.atp.open();
    amazingTimePicker.afterClose().subscribe(time => {
      $('#time').val(time);
      this.time = time;
      console.log('this.time', this.time);
    });
  }

  upadteSpendingAmount(filter, filterValue) {
    if ( filter === '0' ){
      this.spendingAmount.disable = true;
      this.spendingAmount.value = null;
    } else {
      this.spendingAmount.disable = false;
    }
    this.spendingAmount.filter = filter;
    this.spendingAmount.filterValue = filterValue;
  }
  upadtenoOfOrder(filter, filterValue) {
    if ( filter === '0' || filter === '3' ){
      this.noOfOrder.disable = true;
      this.noOfOrder.value = null;
    } else {
      this.noOfOrder.disable = false;
    }
    this.noOfOrder.filter = filter;
    this.noOfOrder.filterValue = filterValue;
  }
  upadteAge(filter, filterValue) {
    if ( filter === '0' ){
      this.age.disable = true;
      this.age.value = null;
    } else {
      this.age.disable = false;
    }
    this.age.filter = filter;
    this.age.filterValue = filterValue;
  }
  upadteOrderCondition(filter, filterValue) {
    this.orderCondition.filter = filter;
    this.orderCondition.filterValue = filterValue;
  }

  createEvient(){
    this.time = $('#time').val();
    this.eventType = $('#eventType').val();
    this.region = $('#region').val();
    this.business = $('#business').val();
    this.phoneNumberRegion = $('#phoneNumberRegion').val();

    if ( this.eventType !== '2' && this.title === '') {
      toastr.error('Please add event title');
      return;
    }
    if (this.date === '' || this.date === undefined || this.date === null) {
      toastr.error('Please select event date');
      return;
    }
    if (this.time === '' || this.time === undefined) {
      toastr.error('Please select event time');
      return;
    }
    if (this.spendingAmount.filter !== '0' && ( this.spendingAmount.value === null || this.spendingAmount.value === undefined || this.spendingAmount.value < 0 ) ) {
      toastr.error('Please add most spending amount');
      return;
    }
    if (this.noOfOrder.filter !== '0' && this.noOfOrder.filter !== '3' && ( this.noOfOrder.value === null || this.noOfOrder.value === undefined || this.noOfOrder.value < 0 ) ) {
      toastr.error('Please add number of order');
      return;
    }
    if (this.age.filter !== '0' && ( this.age.value === null || this.age.value === undefined || this.age.value < 1 ) ) {
      toastr.error('Please add age');
      return;
    }
    if (this.text === '') {
      toastr.error('Please add event message');
      return;
    }
    this.disableBtn = true;

    // var today = new Date();
    // var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    var dateAndTime = new Date(this.date.formatted +' '+this.time+':00').toISOString();
    console.log('isoDate', dateAndTime);

    this.dataService.createEvient(window.localStorage.getItem('token'), this.time, this.eventType, this.title, this.region, this.business, this.phoneNumberRegion, this.spendingAmount, this.noOfOrder, this.age, this.text, this.date.formatted, dateAndTime, this.orderCondition).subscribe(
      (data) => {
        this.addEventData = data;
        if ( this.addEventData.success === true ) {
          $('#addEvent').modal('hide');
          this.getEvents();
          toastr.success('Event create successful');
        } else {
          toastr.error('Something went wrong');
        }
        this.disableBtn = false;
      },
      (error) => {
      }
    );

  }


  callEditEvientFun(){
    this.time = $('#time').val();
    this.eventType = $('#eventType').val();
    this.region = $('#region').val();
    this.business = $('#business').val();
    this.phoneNumberRegion = $('#phoneNumberRegion').val();

    if ( this.eventType !== '2' && this.title === '') {
      toastr.error('Please add event title');
      return;
    }
    if (this.date === '' || this.date === undefined || this.date === null) {
      toastr.error('Please select event date');
      return;
    }
    if (this.time === '' || this.time === undefined) {
      toastr.error('Please select event time');
      return;
    }
    if (this.spendingAmount.filter !== '0' && ( this.spendingAmount.value === null || this.spendingAmount.value === undefined || this.spendingAmount.value < 0 ) ) {
      toastr.error('Please add most spending amount');
      return;
    }
    if (this.noOfOrder.filter !== '0' && this.noOfOrder.filter !== '3' && ( this.noOfOrder.value === null || this.noOfOrder.value === undefined || this.noOfOrder.value < 0 ) ) {
      toastr.error('Please add number of order');
      return;
    }
    if (this.age.filter !== '0' && ( this.age.value === null || this.age.value === undefined || this.age.value < 1 ) ) {
      toastr.error('Please add age');
      return;
    }
    if (this.text === '') {
      toastr.error('Please add event message');
      return;
    }
    this.disableBtn = true;

    console.log('this.time', this.time, this.business);
    // var today = new Date();
    // var time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
    var dateAndTime = new Date(this.date.formatted+' '+this.time+':00').toISOString();
    console.log('isoDate', dateAndTime);
    this.dataService.updateEvient(window.localStorage.getItem('token'), this.time, this.eventType, this.title, this.region, this.business, this.phoneNumberRegion, this.spendingAmount, this.noOfOrder, this.age, this.text, this.date.formatted, dateAndTime, this.editEventsId, this.orderCondition).subscribe(
      (data) => {
        this.addEventData = data;
        if ( this.addEventData.success === true ) {
          $('#addEvent').modal('hide');
          this.getEvents();
          toastr.success('Event update successful');
        } else {
          toastr.error('Something went wrong');
        }
        this.disableBtn = false;
      },
      (error) => {
      }
    );

  }

  getCustomerEventList(){
    this.time = $('#time').val();
    this.eventType = $('#eventType').val();
    this.region = $('#region').val();
    this.business = $('#business').val();
    this.phoneNumberRegion = $('#phoneNumberRegion').val();

    if ( this.eventType !== '2' && this.title === '') {
      toastr.error('Please add event title');
      return;
    }
    if (this.date === '' || this.date === undefined || this.date === null) {
      toastr.error('Please select event date');
      return;
    }
    if (this.time === '' || this.time === undefined) {
      toastr.error('Please select event time');
      return;
    }
    if (this.spendingAmount.filter !== '0' && ( this.spendingAmount.value === null || this.spendingAmount.value === undefined || this.spendingAmount.value < 0 ) ) {
      toastr.error('Please add most spending amount');
      return;
    }
    if (this.noOfOrder.filter !== '0' && this.noOfOrder.filter !== '3' && ( this.noOfOrder.value === null || this.noOfOrder.value === undefined || this.noOfOrder.value < 0 ) ) {
      toastr.error('Please add number of order');
      return;
    }
    if (this.age.filter !== '0' && ( this.age.value === null || this.age.value === undefined || this.age.value < 1 ) ) {
      toastr.error('Please add age');
      return;
    }
    if (this.text === '') {
      toastr.error('Please add event message');
      return;
    }

    console.log('this.time', this.time, this.business);
    var dateAndTime = new Date(this.date.formatted+' '+this.time+':00').toISOString();
    console.log('isoDate', dateAndTime);
    this.customerPageCount = 0;
    this.nao.go(30);
    this.customerEventTotal = 0;
    this.dataService.getCustomerEventList(window.localStorage.getItem('token'), this.time, this.eventType, this.title, this.region, this.business, this.phoneNumberRegion, this.spendingAmount, this.noOfOrder, this.age, this.text, this.date.formatted, dateAndTime, this.editEventsId, this.orderCondition, this.limit, this.customerPageCount).subscribe(
      (data) => {
        this.customerEventData = data;
        this.nao.go(100);
        this.customerEventTotal = this.customerEventData.total;
        this.customerLastPage = this.customerEventData.last_page;
        this.customerPageCount++;
        this.customerEventData = this.customerEventData.items;
          $('#customerEventList').modal('show');
      },
      (error) => {
        this.nao.go(100);
      }
    );

  }

  getCustomerEventListByPageFunction() {
    console.log('this.time', this.time, this.business);
    var dateAndTime = new Date(this.date.formatted+' '+this.time+':00').toISOString();
    console.log('isoDate', dateAndTime);
    this.nao.go(30);
    this.dataService.getCustomerEventList(window.localStorage.getItem('token'), this.time, this.eventType, this.title, this.region, this.business, this.phoneNumberRegion, this.spendingAmount, this.noOfOrder, this.age, this.text, this.date.formatted, dateAndTime, this.editEventsId, this.orderCondition, this.limit, this.customerPageCount).subscribe(
      (data) => {
        this.nao.go(100);
        this.customerPaginatedDataEvents = data;
        this.customerLastPage = this.customerPaginatedDataEvents.last_page;
        this.customerPageCount++;
        this.customerPaginatedDataEvents = this.customerPaginatedDataEvents.items;
        for ( var i = 0; i < this.customerPaginatedDataEvents.length; i++) {
          this.customerEventData.push(this.customerPaginatedDataEvents[i]);
        }
      },
      (error) => {
        this.nao.go(100);
      }
    );
  }


  editEventFun(id, event) {
    this.editDisable = false;
    $('#addEvent').modal('show');
    var des_id;
    des_id = Number(event.region_id);
    if ( des_id === 0 ) {
      this.businessListing = this.serviceAreaData.all_business_list;
    } else {
      for ( var i = 0; i < this.serviceAreaListing.length; i++ ) {
        if ( this.serviceAreaListing[i].id === des_id ) {
          this.businessListing = this.serviceAreaListing[i].business_list;
        }
      }
    }

    setTimeout(() => {
      this.updateBusinessList(event.region_id);
      console.log('event', event);
      this.editEvent = true;
      this.editEventsId = id;


      this.disableBtn = false;
      this.text = event.text;
      this.title = event.title;
      // this.date = event.date;

      this.selDate = event.date;
      this.eventType = event.event_type;
      $('#time').val(event.time);
      $('#eventType').val(event.event_type);
      $('#region').val(event.region_id);
      $('#phoneNumberRegion').val(event.phone_number_region);

      if ( event.spending_amount_filter === '0' ) {
        this.spendingAmount = {
          'value': null,
          'filter': '0',
          'filterValue': 'All',
          'disable': true
        };
      }
      if ( event.spending_amount_filter === '1' ) {
        this.spendingAmount = {
          'value': event.spending_amount,
          'filter': '1',
          'filterValue': 'More Than',
          'disable': false
        };
      }
      if ( event.spending_amount_filter === '2' ) {
        this.spendingAmount = {
          'value': event.spending_amount,
          'filter': '2',
          'filterValue': 'Less Than',
          'disable': false
        };
      }
      if ( event.no_of_order_filter === '0' ) {
        this.noOfOrder = {
          'value': null,
          'filter': '0',
          'filterValue': 'All',
          'disable': true
        };
      }
      if ( event.no_of_order_filter === '1' ) {
        this.noOfOrder = {
          'value': event.no_of_order,
          'filter': '1',
          'filterValue': 'More Than',
          'disable': false
        };
      }
      if ( event.no_of_order_filter === '2' ) {
        this.noOfOrder = {
          'value': event.no_of_order,
          'filter': '2',
          'filterValue': 'Less Than',
          'disable': false
        };
      }
      if ( event.no_of_order_filter === '3' ) {
        this.noOfOrder = {
          'value': event.no_of_order,
          'filter': '3',
          'filterValue': 'No Order',
          'disable': false
        };
      }
      if ( event.age_filter === '0' ) {
        this.noOfOrder = {
          'value': null,
          'filter': '0',
          'filterValue': 'All',
          'disable': true
        };
      }
      if ( event.age_filter === '1' ) {
        this.age = {
          'value': event.age,
          'filter': '1',
          'filterValue': 'More Than',
          'disable': false
        };
      }
      if ( event.age_filter === '2' ) {
        this.age = {
          'value': event.age,
          'filter': '2',
          'filterValue': 'Less Than',
          'disable': false
        };
      }
      if ( event.order_interpreter === '0' ) {
        this.orderCondition = {
          'filter': '0',
          'filterValue': 'AND',
        };
      }
      if ( event.order_interpreter === '1' ) {
        this.orderCondition = {
          'filter': '1',
          'filterValue': 'OR',
        };
      }
      $('#business').val(event.dispensary_id);
    }, 20);
  }

  seeSendeEventDetail(id, event) {
    this.editDisable = true;
    $('#addEvent').modal('show');
    var des_id;
    des_id = Number(event.region_id);
    if ( des_id === 0 ) {
      this.businessListing = this.serviceAreaData.all_business_list;
    } else {
      for ( var i = 0; i < this.serviceAreaListing.length; i++ ) {
        if ( this.serviceAreaListing[i].id === des_id ) {
          this.businessListing = this.serviceAreaListing[i].business_list;
        }
      }
    }

    setTimeout(() => {
      this.updateBusinessList(event.region_id);
      console.log('event', event);
      this.editEvent = true;
      this.editEventsId = id;


      this.disableBtn = false;
      this.text = event.text;
      this.title = event.title;
      // this.date = event.date;

      this.selDate = event.date;
      this.eventType = event.event_type;
      $('#time').val(event.time);
      $('#eventType').val(event.event_type);
      $('#region').val(event.region_id);
      $('#phoneNumberRegion').val(event.phone_number_region);

      if ( event.spending_amount_filter === '0' ) {
        this.spendingAmount = {
          'value': null,
          'filter': '0',
          'filterValue': 'All',
          'disable': true
        };
      }
      if ( event.spending_amount_filter === '1' ) {
        this.spendingAmount = {
          'value': event.spending_amount,
          'filter': '1',
          'filterValue': 'More Than',
          'disable': false
        };
      }
      if ( event.spending_amount_filter === '2' ) {
        this.spendingAmount = {
          'value': event.spending_amount,
          'filter': '2',
          'filterValue': 'Less Than',
          'disable': false
        };
      }
      if ( event.no_of_order_filter === '0' ) {
        this.noOfOrder = {
          'value': null,
          'filter': '0',
          'filterValue': 'All',
          'disable': true
        };
      }
      if ( event.no_of_order_filter === '1' ) {
        this.noOfOrder = {
          'value': event.no_of_order,
          'filter': '1',
          'filterValue': 'More Than',
          'disable': false
        };
      }
      if ( event.no_of_order_filter === '2' ) {
        this.noOfOrder = {
          'value': event.no_of_order,
          'filter': '2',
          'filterValue': 'Less Than',
          'disable': false
        };
      }
      if ( event.no_of_order_filter === '3' ) {
        this.noOfOrder = {
          'value': event.no_of_order,
          'filter': '3',
          'filterValue': 'No Order',
          'disable': false
        };
      }
      if ( event.age_filter === '0' ) {
        this.noOfOrder = {
          'value': null,
          'filter': '0',
          'filterValue': 'All',
          'disable': true
        };
      }
      if ( event.age_filter === '1' ) {
        this.age = {
          'value': event.age,
          'filter': '1',
          'filterValue': 'More Than',
          'disable': false
        };
      }
      if ( event.age_filter === '2' ) {
        this.age = {
          'value': event.age,
          'filter': '2',
          'filterValue': 'Less Than',
          'disable': false
        };
      }
      if ( event.order_interpreter === '0' ) {
        this.orderCondition = {
          'filter': '0',
          'filterValue': 'AND',
        };
      }
      if ( event.order_interpreter === '1' ) {
        this.orderCondition = {
          'filter': '1',
          'filterValue': 'OR',
        };
      }
      $('#business').val(event.dispensary_id);
    }, 20);
  }
  getTitleLength(e){
    var titleMax = 50;
    if (e.which < 0x20) {
      return;
    }
    if (this.title.length === titleMax) {
      e.preventDefault();
    } else if (this.title.length > titleMax) {
      this.title = this.title.substring(0, titleMax);
    }
  }
  getMessageLength(e){
    var max = 160;
    if (e.which < 0x20) {
      return;
    }
    if (this.text.length === max) {
      e.preventDefault();
    } else if (this.text.length > max) {
      this.text = this.text.substring(0, max);
    }
  }
  ngOnInit() {
    var contax = this;
    $(document).ready(function() {
      $("#text").bind('paste', function(e) {
        var max = 160;
        setTimeout(() => {
        if (contax.text.length === max) {
          e.preventDefault();
        } else if (contax.text.length > max) {
          contax.text = contax.text.substring(0, max);
          contax.chRef.detectChanges();
        }
        },20 );
        contax.chRef.detectChanges();
      });
      $("#title").bind('paste', function(e) {
        var max = 50;
        setTimeout(() => {
        if (contax.title.length === max) {
          e.preventDefault();
        } else if (contax.title.length > max) {
          contax.title = contax.title.substring(0, max);
          contax.chRef.detectChanges();
        }
        },20 );
        contax.chRef.detectChanges();
      });
    });

    $('#customerEventList').on('show.bs.modal', function () {
      $('#addEvent').css('-webkit-filter', 'blur(5px)');
      $('#addEvent').css('-moz-filter', 'blur(5px)');
      $('#addEvent').css('-o-filter', 'blur(5px)');
      $('#addEvent').css('-ms-filter', 'blur(5px)');
      $('#addEvent').css('filter', 'blur(5px)');
    });
    $('#customerEventList').on('hide.bs.modal', function () {
      $('#addEvent').css('-webkit-filter', 'blur(0px)');
      $('#addEvent').css('-moz-filter', 'blur(0px)');
      $('#addEvent').css('-o-filter', 'blur(0px)');
      $('#addEvent').css('-ms-filter', 'blur(0px)');
      $('#addEvent').css('filter', 'blur(0px)');
    });

    $('#spendingAmount').on('keypress keyup blur', function (event) {
      $(this).val($(this).val().replace(/[^0-9\.]/g,''));
      if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
      }
    });
    $('#orderNumber').on('keypress keyup blur', function (event) {
      $(this).val($(this).val().replace(/[^0-9\.]/g,''));
      if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
      }
    });
    $('#age').on('keypress keyup blur', function (event) {
      $(this).val($(this).val().replace(/[^0-9\.]/g,''));
      if ((event.which != 46 || $(this).val().indexOf('.') != -1) && (event.which < 48 || event.which > 57)) {
        event.preventDefault();
      }
    });
    this.getEvents();
    this.serviceAreaList();
    $('.header').css('display', 'inline-block');
    $('.footer').css('display', 'inline-block');
    $('#sidebar').css('display', 'block');
    $('.clearSideSelecteion').css('color', '#3d3d3d');
    $('#events').css('color', '#d77229');
  }

}



// WEBPACK FOOTER //
// ./src/app/events/events.component.ts